<template>
    <el-submenu class="sbmnu" v-if="hasChild" v-show="open" :index="model.name">
        <template slot="title">
            <i :class="'iconfont ' +  model.icon"></i>
            <!-- <img class="icon" :src=" `../../imgs/${model.icon}.png` " alt=""> -->
            <!-- <img class="icon" src="../../imgs/icon-caiwuguanli.png" alt=""> -->
            <span slot="title" style="font-size:15px;">{{model.name}}</span>
        </template>
        <NavItem v-for="(item,index) in model.children" :key="index" :model="item"/>
    </el-submenu>
    <el-menu-item class="itm" style="background: #4b7ed5 !important" v-else v-show="open" :index="model.url">
        <i :class="'iconfont ' +  model.icon" style="font-size: 16px"></i>
        <span slot="title" :id="model.menuId">{{model.name}}</span>
    </el-menu-item>
</template>
<script>
    import '@/assets/font/iconfont.css';
    export default {
        name: 'NavItem',
        props: ['model'],
        data() {
            return {
                open: true
            }
        },
        computed: {
            hasChild: function () {
                var flag = this.model.children != undefined;
                return flag;
            },
        },
        methods: {},
        created() {
            
        },
        mounted() {
            
        }
    }
</script>
<style scoped>
    .el-menu-item .menuIcon, .el-submenu__title .menuIcon {
        margin-right: 15px;
        font-size: 20px;
    }

    .menu {
        width: 210px;
        height: 100%;
        background: #fff;
        box-shadow: 1px 2px 3px rgba(0, 0, 0, 0.1);
    }

    .menu .el-menu-item {
        max-width: auto !important;
        height: 50px !important;
        line-height: 50px !important;
    }

    .el-menu-item i {
        font-size: 20px;
    }
    .iconfont{
        color: #fff;
    }
    .itm{
        background: #4b7ed5 ;
    }
    .icon{
        /* width: 18px;
        height: 18px; */
        /* line-height: 18px; */
    }
</style>





// WEBPACK FOOTER //
// src/pages/menu/menu_item.vue